import { BasicButton, Stack, Text } from "@certn/cascadia";
import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

export function InterCheckLogin() {
  const { t } = useTranslation();
  return (
    <div className={styles.div}>
      <Stack gap="space-2">
        <Text style="global/title-medium" color="text-base">
          {t("InterCheck Australia")}
        </Text>
        <Text style="form/body-primary" color="text-weak">
          {t("For APAC customers who use the InterCheck platform.")}
        </Text>
      </Stack>
      <BasicButton
        rightIcon="arrow_forward"
        onPress={() =>
          (window.location.href =
            "https://secure.policecheckexpress.com.au/pce/login")
        }
        size="medium"
      >
        {t("Log in to InterCheck")}
      </BasicButton>
    </div>
  );
}

const styles = {
  div: css({
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    border: "1px solid var(--border-base)",
    padding: "var(--space-4)",
    borderRadius: "var(--border-radius-3)",
    "@media (max-width: 768px)": {
      flexDirection: "column",
      alignItems: "start",
      gap: "var(--space-6)",
    },
  }),
};
